// extracted by mini-css-extract-plugin
module.exports = {"switch_box":"index_switch_box_1gW68"};